module.exports = __webpack_public_path__ + "img/ai_remove_text2.468f16ea.jpg";